import { create } from 'zustand'
import { wordCountCalculate } from '../modules/utils'

interface QuestionState {
  questions: any[]
  wordCountList: number[]
  checkedList: { number: number; checked: boolean }[]
  reset: () => void
  initialize: (payload: any[]) => void
  toggleShareStatus: (questionNumber: number) => void
  setWordCount: (payload: { questionNumber: number; index: number; count: number }) => void
  setCheckedList: (checkedList: { number: number; checked: boolean }[]) => void
  setAnswer: (payload: { questionNumber: number; answer: string }) => void
  setTutorAnswer: (payload: { questionNumber: number; answer: string }) => void
  setCorrection: (payload: { questionNumber: number; correction: string }) => void
}

const useQuestionStore = create<QuestionState>((set) => ({
  questions: [],
  wordCountList: [],
  checkedList: [],
  reset: () =>
    set({
      questions: [],
      wordCountList: [],
      checkedList: [],
    }),
  initialize: (payload) =>
    set((state) => {
      const initialCheckedList = payload.map((item) => ({
        number: item?.question_number,
        checked: item.student_choice,
      }))
      const getInitialWordCountList = (qList) => {
        const tempArr = []
        qList.forEach((qItem) => {
          tempArr.push(wordCountCalculate(qItem.requested_text?.content))
        })
        return tempArr
      }
      return {
        questions: payload,
        checkedList: initialCheckedList,
        wordCountList: getInitialWordCountList(payload),
      }
    }),
  toggleShareStatus: (questionNumber) =>
    set((state) => {
      const targetIdx = state.questions.findIndex((item) => item?.question_number === questionNumber)
      if (targetIdx > -1 && state.questions[targetIdx].student_answer) {
        state.questions[targetIdx].student_answer.share_status = !state.questions[targetIdx].student_answer.share_status
      } else if (targetIdx > -1) {
        state.questions[targetIdx].student_answer = {
          ...state.questions[targetIdx].student_answer,
          share_status: true,
        }
      }
      return { questions: state.questions }
    }),
  setWordCount: (payload) =>
    set((state) => {
      const targetIdx = state.questions.findIndex((item) => item?.question_number === payload.questionNumber)
      if (state.wordCountList[payload.index]) {
        state.wordCountList[payload.index] = payload.count
      }
      if (targetIdx > -1 && state.questions[targetIdx]) {
        state.wordCountList[targetIdx] = payload.count
      }
      return { wordCountList: state.wordCountList }
    }),
  setCheckedList: (checkedList) => set({ checkedList }),
  setAnswer: (payload) =>
    set((state) => {
      const targetIdx = state.questions.findIndex((item) => item?.question_number === payload.questionNumber)
      if (targetIdx > -1 && state.questions[targetIdx]) {
        if (state.questions[targetIdx].student_answer) {
          state.questions[targetIdx].student_answer.content = payload.answer
        } else {
          state.questions[targetIdx].student_answer = { content: payload.answer }
        }
      }
      return { questions: state.questions }
    }),
  setTutorAnswer: (payload) =>
    set((state) => {
      const targetIdx = state.questions.findIndex((item) => item?.question_number === payload.questionNumber)
      if (targetIdx > -1 && state.questions[targetIdx]) {
        if (state.questions[targetIdx].tutor_answer) {
          state.questions[targetIdx].tutor_answer.content = payload.answer
        } else {
          state.questions[targetIdx].tutor_answer = { content: payload.answer }
        }
      }
      return { questions: state.questions }
    }),
  setCorrection: (payload) =>
    set((state) => {
      const targetIdx = state.questions.findIndex((item) => item?.question_number === payload.questionNumber)
      if (targetIdx > -1 && state.questions[targetIdx]) {
        if (state.questions[targetIdx].requested_text) {
          state.questions[targetIdx].requested_text.content = payload.correction
        } else {
          state.questions[targetIdx].requested_text = { content: payload.correction }
        }
      }
      return { questions: state.questions }
    }),
}))

export default useQuestionStore
